var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_6927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_6927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.7327C11.725 18.7327 11.4896 18.6342 11.2938 18.4372C11.0979 18.2403 11 18.0035 11 17.7269C11 17.4503 11.0979 17.2135 11.2938 17.0166C11.4896 16.8196 11.725 16.7211 12 16.7211C12.275 16.7211 12.5104 16.8196 12.7063 17.0166C12.9021 17.2135 13 17.4503 13 17.7269C13 18.0035 12.9021 18.2403 12.7063 18.4372C12.5104 18.6342 12.275 18.7327 12 18.7327ZM12 13.1622C11.725 13.1622 11.4896 13.0637 11.2938 12.8667C11.0979 12.6697 11 12.433 11 12.1564C11 11.8798 11.0979 11.643 11.2938 11.446C11.4896 11.2491 11.725 11.1506 12 11.1506C12.275 11.1506 12.5104 11.2491 12.7063 11.446C12.9021 11.643 13 11.8798 13 12.1564C13 12.433 12.9021 12.6697 12.7063 12.8667C12.5104 13.0637 12.275 13.1622 12 13.1622ZM12 7.59164C11.725 7.59164 11.4896 7.49316 11.2938 7.29619C11.0979 7.09923 11 6.86245 11 6.58586C11 6.30927 11.0979 6.07249 11.2938 5.87553C11.4896 5.67856 11.725 5.58008 12 5.58008C12.275 5.58008 12.5104 5.67856 12.7063 5.87553C12.9021 6.07249 13 6.30927 13 6.58586C13 6.86245 12.9021 7.09923 12.7063 7.29619C12.5104 7.49316 12.275 7.59164 12 7.59164Z",
    fill: "#232323"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.10adfede402924c1a57a278fd100ac5f.svg";
export { ForwardRef as ReactComponent };